import { useNavigate } from "react-router-dom";
import styles from "./ScaleCard.module.css";

import CollapsibleClinicalSection from "../common/CollapsibleClinicalSection";
import Button from "../common/Button";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";

export default function ScaleCard({
  id,
  title,
  process,
  description,
  actionLabel,
  actionTo,
}) {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext);

  return (
    <section className={styles.card}>
      {/* ================= HEADER FIXO ================= */}
      <div className={styles.header}>
        <div>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.process}>{process}</p>
        </div>

        {userData?.entitlements?.groupDiscussion?.active === true ? (
          <Button
            onClick={() => navigate(actionTo)}
            aria-label={`Responder escala ${title}`}
          >
            {actionLabel}
          </Button>
        ) : (
          <Button onClick={() => navigate("/about-group")}>
            Para utilizar a ferramenta é preciso fazer
            <br /> inscrição no grupo de discussões
          </Button>
        )}
      </div>

      {/* ================= DESCRIÇÃO CURTA ================= */}
      <p className={styles.description}>{description}</p>

      {/* ================= ENQUADRE CLÍNICO ================= */}
      <div className={styles.clinical}>
        <CollapsibleClinicalSection title="O que esta escala avalia">
          <p>
            Esta escala é utilizada como um instrumento de autoobservação
            estruturada, auxiliando a identificar padrões relevantes para o
            processo terapêutico.
          </p>
        </CollapsibleClinicalSection>

        <CollapsibleClinicalSection title="Quando faz sentido utilizá-la">
          <p>
            Pode ser útil em momentos de exploração inicial, acompanhamento de
            processos específicos ou quando há necessidade de organizar a
            percepção do próprio funcionamento.
          </p>
        </CollapsibleClinicalSection>

        <CollapsibleClinicalSection title="Como interpretar os resultados">
          <p>
            Os resultados devem ser compreendidos de forma contextual e
            provisória, sempre integrados à formulação clínica e à história de
            vida da pessoa.
          </p>
        </CollapsibleClinicalSection>

        <CollapsibleClinicalSection title="Limites e cuidados">
          <p>
            Esta escala não possui finalidade diagnóstica e não substitui a
            avaliação clínica realizada por um profissional qualificado.
          </p>
        </CollapsibleClinicalSection>
      </div>
    </section>
  );
}
